import React from 'react'
import {
  Container,
  Button,
  Icon,
  TextCaption,
  TextBody
} from '@pmi/pmi-iqos-ds-react'

const CheckoutProfileInfo = ({
  contactInfo,
  handleEditProfileClick,
  showEmail,
  isReplacement,
  checkoutEmailDescription,
  translations
}) => {
  const fullName = (contactInfo && contactInfo.fullName) || ''
  const phone = (contactInfo && contactInfo.phone) || ''
  const email = (contactInfo && contactInfo.email) || ''

  return (
    <Container>
      <Container
        display={Container.displays.flex}
        flexDirection={Container.flexDirections.column}>
        <Container
          display={Container.displays.flex}
          flexDirection={
            isReplacement
              ? Container.flexDirections.column
              : [Container.flexDirections.column, Container.flexDirections.row]
          }>
          <Container
            display={Container.displays.flex}
            width={isReplacement ? 'full' : ['full', '1/2']}
            pb={isReplacement ? '6' : ['6', '0']}>
            <Container width="1/2">
              <TextCaption size={TextCaption.sizes.m}>
                {translations.tk_checkoutFullName}
              </TextCaption>
            </Container>
            <Container width="1/2">
              <TextBody
                size={TextBody.sizes.m}
                data-testing="Checkout_TextBody_Fullname">
                {fullName}
              </TextBody>
            </Container>
          </Container>
          <Container
            display={Container.displays.flex}
            width={isReplacement ? 'full' : ['full', '1/2']}>
            <Container width="1/2">
              <TextCaption size={TextCaption.sizes.m}>
                {translations.tk_checkoutPhone}
              </TextCaption>
            </Container>
            <Container width="1/2">
              <TextBody
                size={TextBody.sizes.m}
                data-testing="Checkout_TextBody_Phone">
                {phone}
              </TextBody>
            </Container>
          </Container>
        </Container>
        {showEmail && (
          <Container display={Container.displays.flex} fullWidth pt="6">
            <Container width={isReplacement ? '1/2' : ['1/2', '1/4']}>
              <TextCaption size={TextCaption.sizes.m}>
                {translations.tk_checkoutEmail}
              </TextCaption>
            </Container>
            <Container width={isReplacement ? '1/2' : ['1/2', '3/4']}>
              <TextBody
                size={TextBody.sizes.m}
                data-testing="Checkout_TextBody_Email">
                {email}
              </TextBody>
            </Container>
          </Container>
        )}
      </Container>
      {checkoutEmailDescription && (
        <Container pt={['6', '8']}>
          <TextBody
            size={TextBody.sizes.s}
            acceptsHtml
            value={checkoutEmailDescription}
          />
        </Container>
      )}
      {handleEditProfileClick && (
        <Container pt={['4', '6']}>
          <Container pt={['2', '4']}>
            <Button
              variant={Button.variants.tertiary}
              onClickHandler={handleEditProfileClick}
              text={translations.tk_checkoutEditProfileButton}
              icon={Icon.images.address}
              iconPosition={Button.iconPositions.right}
              data-testing="Checkout_Button_EditProfile"
            />
          </Container>
        </Container>
      )}
    </Container>
  )
}

export default CheckoutProfileInfo
